import React, { useEffect, useState } from "react";
import { createUseStyles } from "react-jss";
import PropTypes from "prop-types";
import _ from "lodash";
import jssVariables from "../../jss_setup";
import { useSelector } from "react-redux";
import MainSearchForm from "../../components/MainSearchForm";
import { usePropertyLangTag } from "../../hooks";

const notShowProdsMobile = ["CAR", "TRF"];

const styles = createUseStyles({
  SearchForm: (props) => ({
    position: "relative",
    width: "100vw",
    top: jssVariables.navbar_height,
    padding: jssVariables.normal_gap,
    paddingBottom: `calc(${jssVariables.navbar_height} * 2)`,
    height: `calc(100vh - ${jssVariables.navbar_height})`,
    ..._.get(props, "customStyles.SearchForm", {}),
  }),
  backgroundImg: (props) => ({
    position: "absolute",
    top: 0,
    left: 0,
    height: "100%",
    width: "100vw",
    objectFit: "cover",
    zIndex: -1,
    ..._.get(props, "customStyles.backgroundImg", {}),
  }),
  headerContr: (props) => ({
    display: props.showOnMobile ? "block" : "none",
    position: "absolute",
    top: `calc(calc(${props.titleFromTop}px / 2) - ${jssVariables.navbar_height})`,
    left: "50%",
    transform: "translateX(-50%)",
    width: "100%",
    ..._.get(props, "customStyles.headerContr", {}),
  }),
  title: (props) => ({
    fontSize: "x-large",
    fontWeight: 700,
    textAlign: "center",
    color: "white",
    ..._.get(props, "customStyles.title", {}),
  }),
  subtitle: (props) => ({
    fontSize: "medium",
    fontWeight: 500,
    textAlign: "center",
    color: "white",
    ..._.get(props, "customStyles.subtitle", {}),
  }),
  footnotes: {
    display: "grid",
    gridGap: jssVariables.half_gap,
    position: "absolute",
    bottom: jssVariables.normal_gap,
    left: jssVariables.normal_gap,
    fontWeight: 500,
    zIndex: 9999,
    color: jssVariables.colors.text.light,
  },
  [`@media ${jssVariables.media.smallscreen}`]: {
    headerContr: (props) => ({
      display: "block",
      top: "20%",
      ..._.get(props, "customStyles.headerContr.smallscreen", {}),
    }),
    title: (props) => ({
      fontSize: "xxx-large",
      ..._.get(props, "customStyles.title.smallscreen", {}),
    }),
    subtitle: (props) => ({
      fontSize: "x-large",
      ..._.get(props, "customStyles.subtitle.smallscreen", {}),
    }),
  },
  [`@media ${jssVariables.media.bigscreen}`]: {},
});
const SearchForm = ({ product_type, theme }) => {
  const langTag = usePropertyLangTag();
  const [productTypeLcl, setProductTypeLcl] = useState("");
  const [mainSearchFormPosition, setMainSearchFormPosition] = useState(0);

  const classes = styles({
    titleFromTop: mainSearchFormPosition,
    showOnMobile: !notShowProdsMobile.includes(productTypeLcl),
  });

  const list_page_data = useSelector((state) =>
    state.WebsiteMetadata.metadata.list_pages.find(
      (page) => page.theme === theme
    )
  );

  useEffect(() => {
    setProductTypeLcl(product_type);
  }, []);

  const footnotes = list_page_data?.footnotes ?? [];

  return productTypeLcl ? (
    <div className={classes.SearchForm}>
      <img
        className={classes.backgroundImg}
        alt=""
        src={list_page_data?.images?.[0]?.photo_xl_url ?? ""}
      />
      <div className={classes.headerContr}>
        <div className={classes.title}>
          {list_page_data?.[`title${langTag}`]}
        </div>
        <div className={classes.subtitle}>
          {list_page_data?.[`subtitle${langTag}`]}
        </div>
      </div>
      <MainSearchForm
        setMainSearchFormPosition={setMainSearchFormPosition}
        product_type_fixed={productTypeLcl}
        hasSingleProduct={true}
      />
      {footnotes.length > 0 && (
        <div className={classes.footnotes}>
          {footnotes.map((note, idx) => (
            <span key={idx}>{note.en}</span>
          ))}
        </div>
      )}
    </div>
  ) : null;
};
SearchForm.defaultProps = {};
SearchForm.propTypes = {
  product_type: PropTypes.string.isRequired,
  theme: PropTypes.object.isRequired,
};
export default SearchForm;
